import { request } from '@/utils/request'

// 用户角色类型
export type UserRole = 'CLIENT' | 'WRITER' | 'ADMIN'

// 用户信息接口
export interface User {
  id: number
  name: string
  phone: string
  role: UserRole
  last_login_at: string
  created_at: string
  updated_at: string
}

// 用户列表响应接口
export interface UserListResponse {
  items: User[]
  meta: {
    total: number
    page_size: number
    page: number
  }
}

// 获取用户列表参数接口
export interface GetUsersParams {
  page?: number
  page_size?: number
  search?: string
}

// 创建用户参数接口
export interface CreateUserParams {
  name: string
  phone: string
  password: string
  role: UserRole
}

// 更新用户参数接口
export interface UpdateUserParams {
  name: string
  phone: string
  password: string
}

/**
 * 获取用户列表
 * @param params 查询参数
 * @returns 用户列表
 */
export const getUsers = async (params: GetUsersParams = {}) => {
  const { page = 1, page_size = 20, search = '' } = params

  return request<UserListResponse>({
    url: '/v1/users',
    method: 'GET',
    query: {
      page: String(page),
      page_size: String(page_size),
      search
    }
  })
}

/**
 * 创建用户
 * @param params 用户信息
 * @returns 创建的用户信息
 */
export const createUser = async (params: CreateUserParams) => {
  return request<User>({
    url: '/v1/users',
    method: 'POST',
    body: params
  })
}

/**
 * 更新用户
 * @param userId 用户ID
 * @param params 用户信息
 * @returns 更新后的用户信息
 */
export const updateUser = async (userId: number, params: UpdateUserParams) => {
  return request<User>({
    url: `/v1/users/${userId}`,
    method: 'PUT',
    body: params
  })
}

/**
 * 删除用户
 * @param userId 用户ID
 */
export const deleteUser = async (userId: number) => {
  return request({
    url: `/v1/users/${userId}`,
    method: 'DELETE'
  })
}

/**
 * 获取当前用户信息
 * @returns 用户信息
 */
export const getCurrentUser = async (): Promise<User> => {
  return await request<User>({
    url: '/v1/me',
    method: 'GET'
  })
}
